import maintenanceScreenService from '/src/features/maintenance-screen/api/maintenance-screen-service';

export default async (to) => {
  const { $store: store } = useNuxtApp();
  const routePath = to.path;

  if (/^(\/login|\/forgot-password|\/reset-password|\/verify-otp|\/form).*/gi.test(routePath)) {
    return null;
  }

  const isMaintenanceRoute = routePath === '/maintenance' || routePath === '/maintenance/';
  const hasAdminAccess = store.getters.hasAccess(['Admin']) || store.getters.hasAccess(['All']);
  // if Admin on maintenance page redirect to launchpad
  if (hasAdminAccess && isMaintenanceRoute) {
    return navigateTo('/');
  }
  // if user is not admin
  if (!hasAdminAccess) {
    const hasActiveMaintenance = await maintenanceScreenService.checkActiveMaintenance();
    // if maintenance route and no active maintenance
    if (isMaintenanceRoute && !hasActiveMaintenance) {
      return navigateTo('/');
    }
    // If other routes but maintenance is active go to maintenance
    if (!isMaintenanceRoute && hasActiveMaintenance) {
      return navigateTo('/maintenance');
    }
  }
  return null;
};
